
/**
 * Which properties a surface can carry. Meeting properties belong to an audio
 * surface — its calendar event, its roster, its recording — and to nothing
 * else: a text or canvas surface does not have an empty event, it has no
 * event at all, and the properties panel must omit the row rather than
 * render it blank.
 */
export interface SurfaceCapabilities {
  event: boolean;
  attendees: boolean;
  recording: boolean;
}

const NONE: SurfaceCapabilities = { event: false, attendees: false, recording: false };
const MEETING: SurfaceCapabilities = { event: true, attendees: true, recording: true };

const BY_SURFACE_KIND: Record<string, SurfaceCapabilities> = {
  text: NONE,
  canvas: NONE,
  audio: MEETING,
};

/**
 * `null` is the document root — a container for several unrelated meetings,
 * owning none of their properties. An unrecognised kind degrades to `text`:
 * `surface` is an open string the server stores without validation, so a kind
 * this client predates must not claim properties it cannot render.
 *
 * Takes the one field it reads rather than a whole `SurfaceEntry`, so the
 * title bar — which holds only what the UI store publishes — can ask too.
 * Mirrors `surfaceMeta`.
 */
export function surfaceCapabilities(entry: { surface: string } | null): SurfaceCapabilities {
  if (!entry) return NONE;
  return BY_SURFACE_KIND[entry.surface] ?? BY_SURFACE_KIND.text;
}
